import React, { Component } from 'react';
import { Tag, HTMLTable, InputGroup, Button, Intent, Card, Elevation } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Guilds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      fortressFilter: 'ALL',
      guilds: [
        { rank: 1, name: 'SROFilter_Guild', master: 'Nozich', members: '50/50 [MAX]', union: 'SROFilter_Union', fortress: 'Jangan Fortress', gp: '4,890,200 GP', level: 'Lv. 5' },
        { rank: 2, name: 'Asylum', master: 'Merlin', members: '50/50 [MAX]', union: 'AsylumUnion', fortress: 'Hotan Fortress', gp: '4,510,000 GP', level: 'Lv. 5' },
        { rank: 3, name: 'Legion', master: 'FR_Henry', members: '48/50', union: 'LegionAlliance', fortress: 'Bandit Fortress', gp: '3,920,400 GP', level: 'Lv. 5' },
        { rank: 4, name: 'TwitchArmy', master: 'edjka1985', members: '42/50', union: 'TwitchUnion', fortress: 'None', gp: '2,800,100 GP', level: 'Lv. 5' },
        { rank: 5, name: 'GoldVendors', master: 'GoldCeo', members: '1/50 [Solo Guild]', union: 'None', fortress: 'None', gp: '150,000 GP', level: 'Lv. 2' },
        { rank: 6, name: 'GM_Staff', master: 'HandOfGod', members: '5/50', union: 'AdminUnion', fortress: 'None', gp: '9,999,999 GP', level: 'Lv. 5' },
        { rank: 7, name: 'Spartans', master: '_AntiFire_', members: '50/50 [MAX]', union: 'SROFilter_Union', fortress: 'None', gp: '2,400,000 GP', level: 'Lv. 5' },
        { rank: 8, name: 'Vendetta', master: 'MasterForce', members: '35/50', union: 'LegionAlliance', fortress: 'None', gp: '1,950,000 GP', level: 'Lv. 4' },
        { rank: 9, name: 'SoloCrafter', master: 'CraftMaster', members: '1/50 [Solo Guild]', union: 'None', fortress: 'None', gp: '45,000 GP', level: 'Lv. 1' },
        { rank: 10, name: 'Phoenix', master: 'Milaa', members: '50/50 [MAX]', union: 'AsylumUnion', fortress: 'None', gp: '1,820,000 GP', level: 'Lv. 5' },
      ]
    };
  }

  render() {
    const filtered = this.state.guilds.filter((g) => {
      const matchSearch = g.name.toLowerCase().includes(this.state.search.toLowerCase()) ||
        g.master.toLowerCase().includes(this.state.search.toLowerCase());
      const matchFortress = this.state.fortressFilter === 'ALL' || (this.state.fortressFilter === 'FORTRESS' && g.fortress !== 'None');
      return matchSearch && matchFortress;
    });

    return (
      <SideMenuWrapper>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="display-4 font-italic mb-1" style={{ fontSize: '1.5rem', color: '#182026' }}>
              Guild Database & Fortress War Owners
            </h3>
            <p className="text-muted m-0" style={{ fontSize: '0.85rem' }}>
              Live directory of 984 registered Silkroad Online Guilds and Fortress War Alliances.
            </p>
          </div>
        </div>

        {/* Telemetry Cards */}
        <div className="row mb-4">
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Total Guilds</span>
              <h4 className="m-0" style={{ fontWeight: 800, color: '#182026' }}>984 Guilds</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Level 5 Guilds</span>
              <h4 className="m-0 text-success" style={{ fontWeight: 800 }}>42 Guilds</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Fortress Owners</span>
              <h4 className="m-0 text-warning" style={{ fontWeight: 800 }}>3 Guilds</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Max Members Guilds</span>
              <h4 className="m-0 text-info" style={{ fontWeight: 800 }}>18 Full (50/50)</h4>
            </Card>
          </div>
        </div>

        {/* Search & Filter Bar */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex gap-2">
            <Button
              active={this.state.fortressFilter === 'ALL'}
              onClick={() => this.setState({ fortressFilter: 'ALL' })}
              minimal
              small
              intent={Intent.PRIMARY}
            >
              All Guilds (984)
            </Button>
            <Button
              active={this.state.fortressFilter === 'FORTRESS'}
              onClick={() => this.setState({ fortressFilter: 'FORTRESS' })}
              minimal
              small
              intent={Intent.WARNING}
            >
              Fortress Conquerors (3)
            </Button>
          </div>

          <div style={{ width: '240px' }}>
            <InputGroup
              leftIcon="search"
              placeholder="Search Guild or Master..."
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              small
            />
          </div>
        </div>

        {/* Guilds Table */}
        <HTMLTable bordered condensed striped interactive style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Rank</th>
              <th style={{ color: '#182026' }}>Guild Name</th>
              <th style={{ color: '#182026' }}>Guild Master</th>
              <th style={{ color: '#182026' }}>Members (Max 50)</th>
              <th style={{ color: '#182026' }}>Union</th>
              <th style={{ color: '#182026' }}>Fortress Ownership</th>
              <th style={{ color: '#182026' }}>Guild Points (GP)</th>
              <th style={{ color: '#182026' }}>Level</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((g, idx) => (
              <tr key={idx}>
                <td className="font-weight-bold" style={{ color: '#5c7080' }}>#{g.rank}</td>
                <td className="font-weight-bold" style={{ color: '#106ba3' }}>{g.name}</td>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{g.master}</td>
                <td>
                  <Tag intent={g.members.includes('MAX') ? Intent.SUCCESS : g.members.includes('Solo') ? Intent.NONE : Intent.PRIMARY} round>
                    {g.members}
                  </Tag>
                </td>
                <td style={{ color: '#5c7080' }}>{g.union}</td>
                <td>
                  {g.fortress !== 'None' ? (
                    <Tag intent={Intent.WARNING} icon="crown" round>
                      {g.fortress}
                    </Tag>
                  ) : (
                    <span style={{ color: '#5c7080' }}>-</span>
                  )}
                </td>
                <td className="font-mono text-warning font-weight-bold">{g.gp}</td>
                <td className="font-weight-bold text-success">{g.level}</td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
